import CountryLanding from "@/components/country/CountryLanding";
import { PERU } from "@/data/countryPages";

export default function EOSPeru() {
  return <CountryLanding country={PERU} />;
}
